export const socialLinks = [
  { label: "YouTube", href: "https://www.youtube.com/@cooperlyai" },
  { label: "Instagram", href: "https://www.instagram.com/cooperlyai/" },
  { label: "TikTok", href: "https://www.tiktok.com/@cooperlyai" },
] as const;
